import { useCallback, useRef } from 'react';
import { useSimulationContext } from '../providers/SimulationProvider';
import { MESSAGE_EVENT, MESSAGE_TYPES } from '../constants/simulationConstants';
import { postMessage } from '../helpers/utils';
import userEmotionIntervalConfig from '../config/userEmotionIntervalConfig';
import useEmotionIntervalScheduler from './useEmotionIntervalScheduler';

function useRequestUserEmotionInterval({
  convaiClient,
  isVoiceModeActive,
  isClientInitialized,
  isAiTalking,
  isAiResponseInFlight
}) {
  const { isEmotionRecognitionEnabled } = useSimulationContext();

  const isAiTalkingRef = useRef(isAiTalking);
  const isAiResponseInFlightRef = useRef(isAiResponseInFlight);

  isAiTalkingRef.current = isAiTalking;
  isAiResponseInFlightRef.current = isAiResponseInFlight;

  const intervalDurationMs =
    userEmotionIntervalConfig.USER_EMOTION_INTERVAL_DURATION_MS;

  const requestUserEmotion = useCallback(() => {
    const isConversationIdle =
      !isAiTalkingRef.current && !isAiResponseInFlightRef.current;

    if (
      !isClientInitialized ||
      isVoiceModeActive ||
      !convaiClient?.current ||
      !isConversationIdle
    ) {
      return;
    }

    try {
      postMessage({
        type: MESSAGE_TYPES.REQUEST_USER_EMOTION,
        payload: { event: MESSAGE_EVENT.USER_EMOTION_INTERVAL }
      });
    } catch (error) {
      console.error('[Emotion Interval Error]:', error);
    }
  }, [convaiClient, isClientInitialized, isVoiceModeActive]);

  const isEnabled =
    isClientInitialized && isEmotionRecognitionEnabled && !isVoiceModeActive;
  const isBusy = isAiTalking || isAiResponseInFlight;

  const { cleanupEmotionInterval } = useEmotionIntervalScheduler({
    isEnabled,
    isBusy,
    intervalDurationMs,
    onTick: requestUserEmotion
  });

  return { cleanupEmotionInterval };
}

export default useRequestUserEmotionInterval;
